import { reportEvent } from '@com/core/common/utils/sentry';
import { TModuleGroup } from '@com/core/common/types/catalog';

export default {
    validColor: (value: string, data?: TModuleGroup): void => {
        const regex = RegExp('^#(?:[0-9a-fA-F]{3}){1,2}$');
        if (!regex.test(value)) {
            reportEvent('Invalid hex color', 'static render', 'warning', data);
        }
    },
};
